/**
 * Was bei offenen Aufgaben drangt (F-01, V-01) - rein und getestet.
 *
 * Ueberfaellig ist eine offene Aufgabe, deren Deadline vor heute liegt oder
 * die fuer einen vergangenen Tag eingeplant war und liegen blieb.
 */
import type { LocalDate, Task } from '@/domain/types';

const offen = (t: Task) => t.status !== 'erledigt';

export function istUeberfaellig(t: Task, heute: LocalDate): boolean {
  return offen(t) && Boolean((t.dueDate && t.dueDate < heute) || (t.plannedDate && t.plannedDate < heute));
}

export function istHeute(t: Task, heute: LocalDate): boolean {
  return offen(t) && !istUeberfaellig(t, heute) && (t.plannedDate === heute || t.dueDate === heute);
}

/** Aelteste zuerst - was am laengsten liegt, steht oben. */
export function ueberfaellig(tasks: Task[], heute: LocalDate): Task[] {
  const seit = (t: Task) => [t.dueDate, t.plannedDate].filter((d): d is LocalDate => Boolean(d) && d! < heute).sort()[0]!;
  return tasks.filter((t) => istUeberfaellig(t, heute)).sort((a, b) => seit(a).localeCompare(seit(b)) || a.order - b.order);
}

/** Offene Aufgaben: ueberfaellig, heute, dann nach Deadline und Reihenfolge. */
export function nachDringlichkeit(tasks: Task[], heute: LocalDate): Task[] {
  const rang = (t: Task) => (istUeberfaellig(t, heute) ? 0 : istHeute(t, heute) ? 1 : 2);
  return tasks.filter(offen).sort((a, b) =>
    rang(a) - rang(b)
    || (a.dueDate ?? '9999').localeCompare(b.dueDate ?? '9999')
    || (a.plannedDate ?? '9999').localeCompare(b.plannedDate ?? '9999')
    || a.order - b.order);
}

/** Was heute dran ist (V-01): die wichtigsten drei zuerst, dann nach Reihenfolge. */
export function fuerHeute(tasks: Task[], heute: LocalDate): Task[] {
  return tasks.filter((t) => istHeute(t, heute))
    .sort((a, b) => Number(Boolean(b.isBigThree)) - Number(Boolean(a.isBigThree)) || a.order - b.order);
}
